<template>
    <div class="single-point-result">
        <div class="single-point-result__address" v-if="waypoint">
            <div class="single-point-result__address__title h2">{{waypoint.name}}</div>
            <div class="single-point-result__address__text copy-light">
                {{waypoint.content ? waypoint.content : waypoint.comment}}
            </div>
        </div>
        <div class="single-point-result__actions ui-flex">
            <SmrTooltip v-if="isMAPage" content="Packliste anzeigen" position="bottom">
                <div class="single-point-result__actions__item" @click="packingListHandler">
                    <Icon>
                        <IconPackingList />
                    </Icon>
                </div>
            </SmrTooltip>
            <MoreActions 
                :favourite-object="waypoint" 
                :actions="actions"
                :tooltips="tooltipsContent"
                :tracking-favourite="trackingFavourite"
                @pdf="pdfHandler"
                @share="shareHandler"
                @export="exportHandler"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MoreActions from '@/components/MoreActions.vue'
import Icon from '@components//Icon.vue';
import IconPackingList from '@components/icons/IconPackingList.vue';
import SmrTooltip from '@/components/SmrTooltip.vue'
import eventBus from '@/utils/event-bus';
import { trackGa4Event } from '@/utils/tracking'

export default {
    components: {
        MoreActions,
        Icon,
        IconPackingList,
        SmrTooltip,
    },
    props: {
        waypoint: {
            type: Object
        }
    },
    data() {
        return {
            actions: [
                // {
                //     'icon': 'IconPdf',
                //     'label': 'Ort als PDF speichern / drucken',
                //     'event': 'pdf'
                // },
                // {
                //     'icon': 'IconShare',
                //     'label': 'Ort teilen',
                //     'event': 'share'
                // },
                // {
                //     'icon': 'IconExport',
                //     'label': 'Ort exportieren',
                //     'event': 'export'
                // },
            ],
            tooltipsContent: {
                moreActions: {
                    content: 'Weitere Optionen',
                    position: 'bottom-start'
                },
                favourites: {
                    full: {
                        content: 'Als Favorit entfernen',
                        position: 'right'
                    },
                    empty: {
                        content: 'Als Favorit hinzufügen',
                        position: 'right',
                    }
                } 
            },
            trackingFavourite: 'searchLocation',
        }
    },
    computed: {
        ...mapGetters(['isMAPage']),
    },
    methods: {
        pdfHandler() {
            console.log('handle pdf');
        },
        shareHandler() {
            console.log('handle share');
        },
        exportHandler() {
            console.log('handle export');
        },
        packingListHandler() {
            eventBus.$emit('showPackingList', { location: this.waypoint })
            trackGa4Event({ga4Parameter1Name: 'options', ga4Parameter1Value: 'open', ga4Event: 'packing_list_location'})
        }
    }
}
</script>

<style lang="scss" scoped>
.single-point-result {
    $block: &;
    position: relative;
    padding: 25px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__actions {
        gap: 12px;

        &__item {
            cursor: pointer;
        }
    }
}
</style>